import "jquery";
import "bootstrap";
//import "dompurify";

import "jquery-ajax-unobtrusive";



import { App } from "./App";
import { CommonHelper } from "./Helpers/CommonHelper";

$("document").ready(() => {

    $(document).ajaxComplete(function (event, xhr, settings) {
       $('button').blur();
       CommonHelper.bindDisablingSaveButton();
    });

    new App();
});